/* eslint-disable complexity */
import { AppError, BoxConfigRefType, CosmeticRarity, CosmeticType, NftItemRarity } from '@wolffun/shared/src/types';
import { makeAPICaller } from '@profile/src/utils/fetch';
import { parseAvatarAllowedConfigs, parseAvatarConfigs, parseBalanceHistory, parseBattleRewards, parseBoxDataList, parseBoxHistory, parseCosmeticConfigs, parseCosmeticDetail, parseCosmeticHistory, parseGiftBoxDataList, parseHeroHistory, parseNftHeroInventory, parseRentalHistory, parseSelectedCosmeticsList, parseSkinConfigEntities, parseUser, parseVestingSafeHistory } from './utils';
import { TransactionStatus, TransactionType } from '../models';
import { serverCurrencyToSystemCurrency } from '@wolffun/system-currency';
export const getProfile = makeAPICaller('theta_data_get', '/profile', response => {
  return {
    status: 'ok',
    body: parseUser(response === null || response === void 0 ? void 0 : response.data)
  };
});
export const postConfirmCashout = makeAPICaller('theta_data_post', '/currency/confirmCashout', response => {
  const {
    exchangeRate,
    expiredTime
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      exchangeRate: typeof exchangeRate === 'number' ? exchangeRate : 0,
      expiredTime: typeof expiredTime === 'number' ? expiredTime : 0
    }
  };
});
export const getLimitCashout = makeAPICaller('thetan_world_get', '/wallet/limit-cashout', response => {
  const {
    min,
    max,
    thcSpent
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      minCashOut: serverCurrencyToSystemCurrency(min),
      maxCashOut: serverCurrencyToSystemCurrency(max),
      thcSpent: typeof thcSpent === 'number' ? thcSpent : 0
    }
  };
});
export const getCheckAccountCashout = makeAPICaller('theta_data_get', '/currency/checkAccountCashout', () => {
  return {
    status: 'ok',
    body: undefined
  };
});
export const putSelectCosmetics = makeAPICaller('theta_data_put', '/cosmetics/user/selected', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: Boolean(data)
    }
  };
});
export const getAvatarConfigs = makeAPICaller('theta_data_get', '/userItemsConfig', response => {
  const {
    version,
    avatarConfig
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      avatarConfigVer: typeof version === 'number' ? version : undefined,
      avatarConfigs: parseAvatarConfigs(avatarConfig)
    }
  };
});
export const getIngameBalance = makeAPICaller('theta_data_get', '/currency', response => {
  const {
    balance,
    userCap,
    config
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  const {
    gTHC,
    gTHG,
    gPP,
    gPT,
    gMQP
  } = balance || {};
  const {
    totalTHCClaimed,
    lastTimeClaimedTHC,
    totalTHGClaimed,
    lastTimeClaimedTHG,
    expiredMintHero,
    expiredMintCosmetic
  } = userCap || {};
  const {
    THCSpentQuestionMask,
    timeCapClaimedTHC,
    timeCapClaimedTHG,
    minFeeCashoutTHC,
    minFeeCashoutTHG,
    perFeeCashoutTHC,
    perFeeCashoutTHG,
    timeToClaimToken,
    version
  } = config || {};
  return {
    status: 'ok',
    body: {
      balance: {
        gTHC: serverCurrencyToSystemCurrency(gTHC),
        gTHG: serverCurrencyToSystemCurrency(gTHG),
        gPP: serverCurrencyToSystemCurrency(gPP),
        gPT: serverCurrencyToSystemCurrency(gPT),
        gMQP: serverCurrencyToSystemCurrency(gMQP)
      },
      userCap: userCap ? {
        totalTHCClaimed: typeof totalTHCClaimed === 'number' ? totalTHCClaimed : 0,
        totalTHGClaimed: typeof totalTHGClaimed === 'number' ? totalTHGClaimed : 0,
        lastTimeClaimedTHC: typeof lastTimeClaimedTHC === 'number' ? lastTimeClaimedTHC : 0,
        lastTimeClaimedTHG: typeof lastTimeClaimedTHG === 'number' ? lastTimeClaimedTHG : 0,
        expiredMintHero: typeof expiredMintHero === 'number' ? expiredMintHero * 1000 : 0,
        expiredMintCosmetic: typeof expiredMintCosmetic === 'number' ? expiredMintCosmetic * 1000 : 0
      } : undefined,
      config: config ? {
        thcSpentQuestionMask: typeof THCSpentQuestionMask === 'number' ? THCSpentQuestionMask : 0,
        timeCapClaimedTHC: typeof timeCapClaimedTHC === 'number' ? timeCapClaimedTHC : 0,
        timeCapClaimedTHG: typeof timeCapClaimedTHG === 'number' ? timeCapClaimedTHG : 0,
        minFeeCashoutTHC: typeof minFeeCashoutTHC === 'number' ? minFeeCashoutTHC : 0,
        minFeeCashoutTHG: typeof minFeeCashoutTHG === 'number' ? minFeeCashoutTHG : 0,
        perFeeCashoutTHC: typeof perFeeCashoutTHC === 'number' ? perFeeCashoutTHC : 0,
        perFeeCashoutTHG: typeof perFeeCashoutTHG === 'number' ? perFeeCashoutTHG : 0,
        timeToClaimToken: typeof timeToClaimToken === 'number' ? timeToClaimToken : 0,
        version: typeof version === 'number' ? version : 0
      } : undefined
    }
  };
});
export const claimReferralReward = makeAPICaller('theta_data_post', '/ref/claimRewardRefMKP', response => {
  const {
    success
  } = response || {};
  return {
    status: 'ok',
    body: typeof success === 'boolean' ? success : false
  };
});
export const getAvatarAllowedConfigs = makeAPICaller('theta_data_get', '/userItems', response => {
  const {
    avatars
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      avatars: parseAvatarAllowedConfigs(avatars)
    }
  };
});
export const getCosmeticConfigs = makeAPICaller('theta_data_get', '/cosmetics/config', response => {
  const {
    version,
    cosmeticMap,
    imgPathPattern,
    sellFee,
    pathKey,
    minSale,
    maxSale
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      cosmeticConfigVer: typeof version === 'number' ? version : -1,
      sellFee: typeof sellFee === 'number' ? sellFee : 0,
      minSale: typeof minSale === 'number' ? minSale : 0,
      maxSale: typeof maxSale === 'number' ? maxSale : 0,
      cosmeticConfigs: parseCosmeticConfigs(cosmeticMap, imgPathPattern, pathKey),
      imgPathPattern: typeof imgPathPattern === 'string' ? imgPathPattern : ''
    }
  };
});
export const getSelectedCosmetics = makeAPICaller('theta_data_get', '/cosmetics/user/selected', response => {
  const {
    data
  } = response || {};
  return {
    status: 'ok',
    body: {
      data: parseSelectedCosmeticsList(data)
    }
  };
});
export const getAuthNonce = makeAPICaller('theta_marketplace_get', '/authentication/nonce', response => {
  const {
    nonce,
    address
  } = response || {};

  if (typeof nonce !== 'number') {
    return {
      status: 'error',
      error: AppError.REJECTED_BY_FE,
      debugMessage: 'invalid nonce'
    };
  }

  return {
    status: 'ok',
    body: {
      address: typeof address === 'string' ? address : '',
      nonce: typeof nonce === 'number' ? nonce : 0
    }
  };
});
export const postAuthToken = makeAPICaller('theta_auth_post', '/authentication-token', response => {
  const {
    accessToken,
    refreshToken
  } = response || {};

  if (typeof accessToken !== 'string') {
    return {
      status: 'error',
      error: AppError.REJECTED_BY_FE,
      debugMessage: 'invalid accessToken'
    };
  }

  return {
    status: 'ok',
    body: {
      accessToken: typeof accessToken === 'string' ? accessToken : '',
      refreshToken: typeof refreshToken === 'string' ? refreshToken : ''
    }
  };
});
export const linkWallet = makeAPICaller('theta_marketplace_put', '/profile/wallet', () => {
  return {
    status: 'ok',
    body: undefined
  };
}, res => {
  const {
    errors,
    code: errorCode
  } = res || {};
  let code = AppError.UNNKOWN;

  if (errorCode) {
    code = errorCode;
  }

  if (typeof errors === 'object') {
    if (errors.Address) {
      code = AppError.ADDRESS_EXIST;
    }

    if (errors.Signature) {
      code = AppError.SIGNATURE_INVALID;
    }
  }

  return {
    status: 'error',
    error: code
  };
});
export const getWalletStatus = makeAPICaller('theta_marketplace_get', '/profile/{address}/wallet-status', response => {
  if (typeof response !== 'boolean') {
    return {
      status: 'error',
      error: AppError.REJECTED_BY_FE,
      debugMessage: 'invalid data'
    };
  }

  return {
    status: 'ok',
    body: response
  };
});
export const putWalletConnect = makeAPICaller('theta_data_put', '/user/walletConnect', () => {
  return {
    status: 'ok',
    body: {
      success: true
    }
  };
});
export const createAccount = makeAPICaller('theta_auth_post', '/create-account', response => {
  const {
    accessToken,
    refreshToken
  } = response || {};
  return {
    status: 'ok',
    body: {
      accessToken: typeof accessToken === 'string' ? accessToken : '',
      refreshToken: typeof refreshToken === 'string' ? refreshToken : ''
    }
  };
});
export const loginAccount = makeAPICaller('theta_auth_post', '/login-account', response => {
  const {
    accessToken,
    refreshToken
  } = response || {};
  return {
    status: 'ok',
    body: {
      accessToken: typeof accessToken === 'string' ? accessToken : '',
      refreshToken: typeof refreshToken === 'string' ? refreshToken : ''
    }
  };
});
export const registerEmail = makeAPICaller('theta_auth_post', '/send-code', () => {
  return {
    status: 'ok',
    body: undefined
  };
});
export const openThetanBoxV2 = makeAPICaller('theta_data_post', '/thetanbox/open-box', response => {
  const {
    data,
    itemType
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  let result;

  if (typeof itemType === 'number' && itemType === BoxConfigRefType.COSMETIC) {
    const {
      cosmeticId,
      type,
      typeId,
      name,
      rarity
    } = data || {};
    result = {
      [BoxConfigRefType.COSMETIC]: {
        rarity: typeof rarity === 'number' ? rarity : CosmeticRarity.COMMON,
        name: typeof name === 'string' ? name : '',
        typeId: typeof typeId === 'number' ? typeId : 0,
        type: typeof type === 'number' ? type : CosmeticType.AVATAR,
        cosmeticId: typeof cosmeticId === 'string' ? cosmeticId : ''
      }
    };
  } else if (typeof itemType === 'number' && itemType === BoxConfigRefType.HERO_SKIN) {
    const {
      heroId,
      heroInfo,
      skinInfo
    } = data || {};
    result = {
      [BoxConfigRefType.HERO_SKIN]: {
        heroId: typeof heroId === 'string' ? heroId : '',
        heroInfo: {
          name: typeof (heroInfo === null || heroInfo === void 0 ? void 0 : heroInfo.name) === 'string' ? heroInfo.name : ''
        },
        skinInfo: {
          name: typeof (skinInfo === null || skinInfo === void 0 ? void 0 : skinInfo.name) === 'string' ? skinInfo.name : '',
          heroRarity: typeof (skinInfo === null || skinInfo === void 0 ? void 0 : skinInfo.heroRarity) === 'number' ? skinInfo.heroRarity : NftItemRarity.COMMON,
          imageFull: typeof (skinInfo === null || skinInfo === void 0 ? void 0 : skinInfo.imageFull) === 'string' ? skinInfo.imageFull : '',
          imageAvatar: typeof (skinInfo === null || skinInfo === void 0 ? void 0 : skinInfo.imageAvatar) === 'string' ? skinInfo.imageAvatar : ''
        }
      }
    };
  } else if (typeof itemType === 'number' && itemType === BoxConfigRefType.CURRENCY) {
    result = {
      [BoxConfigRefType.CURRENCY]: {
        value: serverCurrencyToSystemCurrency(data)
      }
    };
  }

  return {
    status: 'ok',
    body: result ? {
      data: result,
      itemType: typeof itemType === 'number' ? itemType : 0
    } : undefined
  };
});
export const postClaimToken = makeAPICaller('thetan_world_post', '/wallet/claim', response => {
  const {
    data
  } = response || {};
  const {
    sender,
    amount,
    expiredAt,
    blockchainID,
    signature,
    tokenAddress,
    transactionID
  } = data || {};
  return {
    status: 'ok',
    body: {
      sender: typeof sender === 'string' ? sender : '',
      amount: serverCurrencyToSystemCurrency(amount),
      expiredAt: typeof expiredAt === 'number' ? expiredAt : 0,
      blockchainID: typeof blockchainID === 'number' ? blockchainID : 0,
      signature: typeof signature === 'string' ? signature : '',
      tokenAddress: typeof tokenAddress === 'string' ? tokenAddress : '',
      transactionID: typeof transactionID === 'number' ? transactionID : 0
    }
  };
});
export const getReferralInfo = makeAPICaller('theta_data_get', '/ref/getRefInfoMKP', response => {
  const {
    refLink,
    numInviteFriends,
    totalNumInviteFriends,
    baseRewards,
    maximumFriends
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      refLink: typeof refLink === 'string' ? refLink : '',
      numInviteFriends: typeof numInviteFriends === 'number' ? numInviteFriends : 0,
      totalNumInviteFriends: typeof totalNumInviteFriends === 'number' ? totalNumInviteFriends : 0,
      baseRewards: serverCurrencyToSystemCurrency(baseRewards),
      maximumFriends: typeof maximumFriends === 'number' ? maximumFriends : 0
    }
  };
});
export const getCosmeticAllInventory = makeAPICaller('theta_data_get', '/cosmetics/user', response => {
  const {
    data
  } = response || {};
  const parsedItems = Array.isArray(data) ? data.map(parseCosmeticDetail) : [];
  return {
    status: 'ok',
    body: {
      data: parsedItems
    }
  };
});
export const getBalanceHistory = makeAPICaller('theta_report_get', '/user/balance', response => {
  const {
    page: paging,
    data
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  const totalItems = typeof (paging === null || paging === void 0 ? void 0 : paging.total) === 'number' ? paging === null || paging === void 0 ? void 0 : paging.total : 0;
  const parsedItems = Array.isArray(data) ? data.map(parseBalanceHistory) : [];
  return {
    status: 'ok',
    body: {
      totalItems,
      data: parsedItems
    }
  };
});
export const getTransactionHistory = makeAPICaller('theta_data_get', '/currency/transaction', response => {
  const {
    page: paging,
    data
  } = response || {};
  const totalItems = typeof (paging === null || paging === void 0 ? void 0 : paging.total) === 'number' ? paging === null || paging === void 0 ? void 0 : paging.total : 0;
  const parsedItems = Array.isArray(data) ? data.map(parseTransaction) : [];
  return {
    status: 'ok',
    body: {
      totalItems,
      data: parsedItems
    }
  };
});
export const parseTransaction = transaction => {
  const {
    id,
    created,
    fromAddress,
    request,
    status,
    type,
    lastModified,
    fee
  } = transaction || {};
  return {
    id: typeof id === 'number' ? id : 0,
    created: typeof created === 'string' ? created : '',
    lastModified: typeof lastModified === 'string' ? lastModified : '',
    fromAddress: typeof fromAddress === 'string' ? fromAddress : '',
    request: serverCurrencyToSystemCurrency(request),
    fee: fee ? serverCurrencyToSystemCurrency(fee) : undefined,
    status: typeof status === 'number' ? status : TransactionStatus.NEW,
    type: typeof type === 'number' ? type : TransactionType.CLAIM
  };
};
export const getUserThetanBoxList = makeAPICaller('theta_data_get', '/thetanbox', res => {
  const {
    boxDataArr
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  return {
    status: 'ok',
    body: parseBoxDataList(boxDataArr).sort((x, y) => x.boxType - y.boxType)
  };
});
export const getCosmeticHistory = makeAPICaller('theta_report_get', '/user/cosmetic', response => {
  const {
    page: paging,
    data
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  const totalItems = typeof (paging === null || paging === void 0 ? void 0 : paging.total) === 'number' ? paging === null || paging === void 0 ? void 0 : paging.total : 0;
  const parsedItems = Array.isArray(data) ? data.map(parseCosmeticHistory) : [];
  return {
    status: 'ok',
    body: {
      totalItems,
      data: parsedItems
    }
  };
});
export const getHeroHistory = makeAPICaller('theta_report_get', '/user/hero', response => {
  const {
    page: paging,
    data
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  const totalItems = typeof (paging === null || paging === void 0 ? void 0 : paging.total) === 'number' ? paging === null || paging === void 0 ? void 0 : paging.total : 0;
  const parsedItems = Array.isArray(data) ? data.map(parseHeroHistory) : [];
  return {
    status: 'ok',
    body: {
      totalItems,
      data: parsedItems
    }
  };
});
export const getRentalHistory = makeAPICaller('theta_report_get', '/user/hero-rental', response => {
  const {
    page: paging,
    data
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  const totalItems = typeof (paging === null || paging === void 0 ? void 0 : paging.total) === 'number' ? paging === null || paging === void 0 ? void 0 : paging.total : 0;
  const parsedItems = Array.isArray(data) ? data.map(parseRentalHistory) : [];
  return {
    status: 'ok',
    body: {
      totalItems,
      data: parsedItems
    }
  };
});
export const getVestingSafeHistory = makeAPICaller('theta_data_get', '/vesting-safe/histories', response => {
  const {
    page: paging,
    data
  } = response || {};
  const totalItems = typeof (paging === null || paging === void 0 ? void 0 : paging.total) === 'number' ? paging === null || paging === void 0 ? void 0 : paging.total : 0;
  const parsedItems = Array.isArray(data) ? data.map(parseVestingSafeHistory) : [];
  return {
    status: 'ok',
    body: {
      totalItems,
      data: parsedItems
    }
  };
});
export const getBattleRewards = makeAPICaller('theta_report_get', '/user/battle', response => {
  const {
    data,
    page
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  const {
    total
  } = page || {};
  const totalItems = typeof total === 'number' ? total : 0;
  const parsedItems = Array.isArray(data) ? data.map(parseBattleRewards) : [];
  return {
    status: 'ok',
    body: {
      data: parsedItems,
      totalItems
    }
  };
});
export const getCosmeticInventory = makeAPICaller('theta_data_get', '/cosmetics/user', response => {
  const {
    data,
    page
  } = response || {};
  const totalItems = typeof (page === null || page === void 0 ? void 0 : page.total) === 'number' ? page === null || page === void 0 ? void 0 : page.total : 0;
  const parsedItems = Array.isArray(data) ? data.map(parseCosmeticDetail) : [];
  return {
    status: 'ok',
    body: {
      data: parsedItems,
      totalItems
    }
  };
});
export const searchInventory = makeAPICaller('theta_data_get', '/hero/user', response => {
  var _data$skinConfigs, _data$skinConfigs2;

  const {
    page,
    data
  } = response || {};
  const {
    total
  } = page || {};
  const totalItems = typeof total === 'number' ? total : 0;
  const parsedItems = Array.isArray(data === null || data === void 0 ? void 0 : data.heroes) ? (data === null || data === void 0 ? void 0 : data.heroes).map(parseNftHeroInventory) : [];
  return {
    status: 'ok',
    body: {
      totalItems,
      heroes: parsedItems,
      skinConfigs: parseSkinConfigEntities(data === null || data === void 0 ? void 0 : data.skinConfigs),
      skinVer: typeof (data === null || data === void 0 ? void 0 : (_data$skinConfigs = data.skinConfigs) === null || _data$skinConfigs === void 0 ? void 0 : _data$skinConfigs.version) === 'number' ? data === null || data === void 0 ? void 0 : (_data$skinConfigs2 = data.skinConfigs) === null || _data$skinConfigs2 === void 0 ? void 0 : _data$skinConfigs2.version : undefined
    }
  };
});
export const fetchReferralFloatingInfo = makeAPICaller('theta_data_get', '/ref/getRefInfoMKPFloating', response => {
  const {
    maximumReward
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      maximumReward: serverCurrencyToSystemCurrency(maximumReward)
    }
  };
});
export const openThetanBox = makeAPICaller('theta_data_post', '/thetanbox/open-box', response => {
  const {
    skinInfo,
    heroInfo,
    heroId
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  return {
    status: 'ok',
    body: {
      heroId: typeof heroId === 'string' ? heroId : '',
      heroInfo: {
        name: typeof (heroInfo === null || heroInfo === void 0 ? void 0 : heroInfo.name) === 'string' ? heroInfo.name : ''
      },
      skinInfo: {
        name: typeof (skinInfo === null || skinInfo === void 0 ? void 0 : skinInfo.name) === 'string' ? skinInfo.name : '',
        heroRarity: typeof (skinInfo === null || skinInfo === void 0 ? void 0 : skinInfo.heroRarity) === 'number' ? skinInfo.heroRarity : NftItemRarity.COMMON,
        imageFull: typeof (skinInfo === null || skinInfo === void 0 ? void 0 : skinInfo.imageFull) === 'string' ? skinInfo.imageFull : '',
        imageAvatar: typeof (skinInfo === null || skinInfo === void 0 ? void 0 : skinInfo.imageAvatar) === 'string' ? skinInfo.imageAvatar : ''
      }
    }
  };
});
export const getUserGiftBoxList = makeAPICaller('theta_data_get', '/thetanbox/giftbox', res => {
  const {
    boxDataArr,
    isInstalledGame
  } = (res === null || res === void 0 ? void 0 : res.data) || {};
  return {
    status: 'ok',
    body: {
      data: parseGiftBoxDataList(boxDataArr).sort((x, y) => x.boxType - y.boxType),
      isInstalledGame: typeof isInstalledGame === 'boolean' ? isInstalledGame : false
    }
  };
});
export const getBoxHistory = makeAPICaller('theta_report_get', '/user/box', response => {
  const {
    page: paging,
    data
  } = (response === null || response === void 0 ? void 0 : response.data) || {};
  const totalItems = typeof (paging === null || paging === void 0 ? void 0 : paging.total) === 'number' ? paging === null || paging === void 0 ? void 0 : paging.total : 0;
  const parsedItems = Array.isArray(data) ? data.map(parseBoxHistory) : [];
  return {
    status: 'ok',
    body: {
      totalItems,
      data: parsedItems
    }
  };
});